"use strict";

exports.__esModule = true;
var _ReportTagContext = require("./ReportTagContext");
Object.keys(_ReportTagContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportTagContext[key]) return;
  exports[key] = _ReportTagContext[key];
});
var _ReportTagController = require("./ReportTagController");
Object.keys(_ReportTagController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportTagController[key]) return;
  exports[key] = _ReportTagController[key];
});